<template>
	<div class="news_list">
		<div class="news_list1" v-if="!isPhone">
			<div class="news_item1 flex1" v-for="(item,index) in nelist" :key="index" @click="toDetail(item)">
				<div class="news_img">
					<img :src="item.image">
				</div>
				<div class="news_text">
					<div class="ellip news_des1 mt_5">{{item.title}}</div>
					<div class="news_time mt_5">{{ item.addtime.slice(0,10) }}</div>
					<div class="ellip2 news_des2 mt_15">{{item.desc}}</div>
				</div>
			</div>
			<div class="flex2 mt_60" v-if="nelist.length">
				<pagination1 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
					@page-change="handlePageChange" />
			</div>
		</div>
		<div class="nelt_ph" v-if="isPhone">
			<div class="news_item1 flex1" v-for="(item,index) in nelist" :key="index" @click="toDetail(item)">
				<div class="news_img">
					<img :src="item.image">
				</div>
				<div class="news_text">
					<div class="ellip news_des1">{{item.title}}</div>
					<div class="news_time">{{ item.addtime.slice(0,10) }}</div>
					<div class="ellip news_des2">{{item.desc}}</div>
				</div>
			</div>
			<div class="flex2 mt_20" v-if="nelist.length">
				<pagination2 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
					@page-change="handlePageChange" />
			</div>
		</div>
	</div>
</template>

<script>
import pagination1 from "../../components/pagination1.vue";
import pagination2 from "../../components/pagination2.vue";
export default {
	components: {
		pagination1,
		pagination2,
	},
	data() {
		return {
			sort: '',//1=集团要闻,2=基层动态,3=安全生产,4=集团报刊
			nelist: [],
			currentPage: 1,
			totalPage: 0,
			totalNum: 0,
			staticImg: this.$staticImg,
			isPhone: this.$isMobile,
		}
	},
	watch: {
		$route: {
			handler(newRoute, oldRoute) {
				this.nelist = [];
				this.currentPage = 1;
				this.totalPage = 0;
				this.totalNum = 0;
				this.sort = newRoute.query.sort;
				this.articlelist();
			},
			deep: true
		}
	},
	created() {
		this.sort = this.$route.query.sort;
		this.articlelist();
	},
	methods: {
		// 业务领域
		async articlelist() {
			var data = {
				status: this.sort,//群团工作
				page: this.currentPage - 1,
				nums: 5
			}
			const res = await this.$api.articlelist(data);
			if (res.code == 1) {
				this.totalNum = res.msg;
				this.totalPage = Math.ceil(Number(this.totalNum) / 5);
				if (res.data.length) {
					this.nelist = res.data;
					for (let i = 0; i < this.nelist.length; i++) {
						if (this.nelist[i].image) {
							if (this.nelist[i].image.indexOf('http') == -1) {
								this.nelist[i].image = this.$staticImg + this.nelist[i].image;
							}
						}
					}
				}
			}
		},
		handlePageChange(newPage) {
			this.currentPage = newPage;
			this.articlelist();
		},
		toDetail(item) {
			this.$router.push("/news/newsDetail?id=" + item.id + "&sort=" + this.sort);
		}
	}
}
</script>

<style lang="scss">
.news_list {
	.news_list1 {
		width: 100%;
		.news_item1 {
			background-color: #f8f8f8;
			padding: 15px;
			align-items: flex-start;
			margin-bottom: 20px;
			cursor: pointer;
			.news_img {
				width: 265px;
				height: 160px;
				overflow: hidden;
				img {
					width: 265px;
					height: 160px;
					transition: transform 0.5s ease;
					&:hover {
						transform: scale(1.05);
					}
				}
			}
			.news_text {
				flex: 1;
				width: 0;
				margin-left: 25px;
				.news_time {
					font-size: 16px;
					color: #b6b6b6;
					line-height: 1.6;
				}
				.news_des1 {
					font-size: 20px;
					color: #000;
					line-height: 1.6;
					font-weight: bold;
					&:hover {
						color: #003f99;
					}
				}
				.news_des2 {
					font-size: 18px;
					color: #898989;
					line-height: 1.6;
					&:hover {
						color: #003f99;
					}
				}
			}
		}
	}
	@media screen and (max-width: 1600px) {
		.news_list1 {
			width: 100%;
			.news_item1 {
				.news_img {
					width: 240px;
					height: 145px;
					overflow: hidden;
					img {
						width: 240px;
						height: 145px;
					}
				}
			}
		}
	}
	.nelt_ph {
		width: 100%;
		padding: 0.3rem;
		.news_item1 {
			background-color: #f8f8f8;
			padding: 0.31rem;
			align-items: flex-start;
			margin-bottom: 0.5rem;
			cursor: pointer;
			.news_img {
				width: 3.8rem;
				height: 2.2rem;
				overflow: hidden;
				img {
					width: 3.8rem;
					height: 2.2rem;
				}
			}
			.news_text {
				flex: 1;
				width: 0;
				margin-left: 0.3rem;
				.news_time {
					font-size: 16px;
					color: #b6b6b6;
					line-height: 1.6;
					margin-top: 0.1rem;
				}
				.news_des1 {
					font-size: 0.36rem;
					color: #000;
					line-height: 1.6;
					font-weight: bold;
					&:hover {
						color: #003f99;
					}
				}
				.news_des2 {
					font-size: 0.36rem;
					color: #898989;
					line-height: 1.6;
					margin-top: 0.1rem;
					&:hover {
						color: #003f99;
					}
				}
			}
		}
	}
}
</style>